module.exports = __webpack_public_path__ + "img/yanglei-qrcode.6cefeacd.png";